import React from 'react';
import FaqItem from './faq-item'

//https://reactjs.org/docs/lists-and-keys.html
class ProductList extends React.Component {
	render() {
		const defaultCssClass = 'faq__list';
		let cssClass = this.props.cssClass ? defaultCssClass + ' ' + this.props.cssClass : defaultCssClass;

		//global helper var defined via WP
		if( wp_core.is_home ) cssClass += ' list--home';

		return (
		<ul className={cssClass}>
	      {this.props.data.map((item, index) =>
	          <FaqItem 
					key={item.id} 
					index = {index}
					title={item.title.rendered} 
					url={item.custom_meta_fields.archive_url}
	          	/>
	        )}
		</ul>
		);
	}
}	

export default ProductList;